<template>
    <svg :height="size" :width="size" viewBox="0 0 25 24" version="1.1">
        <defs>
            <path
                id="path-1"
                d="M16.65625,18.984375 C16.8125,18.984375 16.9453125,18.9296875 17.0546875,18.8203125 C17.1640625,18.7109375 17.21875,18.578125 17.21875,18.421875 C17.2083333,17.7135417 17.0677083,17.0364583 16.796875,16.390625 C16.5364583,15.765625 16.1666667,15.2135417 15.6875,14.734375 C15.2083333,14.2552083 14.65625,13.8854167 14.03125,13.625 C13.8229167,13.53125 13.6041667,13.453125 13.375,13.390625 C14.0104167,13.1822917 14.5677083,12.8385417 15.046875,12.359375 C15.890625,11.515625 16.3125,10.5 16.3125,9.3125 C16.3125,8.125 15.890625,7.11197917 15.046875,6.2734375 C14.203125,5.43489583 13.1875,5.015625 12,5.015625 C10.8125,5.015625 9.79947917,5.43489583 8.9609375,6.2734375 C8.12239583,7.11197917 7.703125,8.125 7.703125,9.3125 C7.703125,10.5 8.11979167,11.515625 8.953125,12.359375 C9.43229167,12.8385417 9.98958333,13.1822917 10.625,13.390625 C10.3854167,13.453125 10.1666667,13.53125 9.96875,13.625 C9.34375,13.8854167 8.79166667,14.2552083 8.3125,14.734375 C7.83333333,15.2135417 7.46354167,15.765625 7.203125,16.390625 C6.93229167,17.0364583 6.796875,17.7135417 6.796875,18.421875 C6.796875,18.578125 6.8515625,18.7109375 6.9609375,18.8203125 C7.0703125,18.9296875 7.203125,18.984375 7.359375,18.984375 C7.515625,18.984375 7.6484375,18.9296875 7.7578125,18.8203125 C7.8671875,18.7109375 7.921875,18.578125 7.921875,18.421875 C7.921875,17.296875 8.3203125,16.3333333 9.1171875,15.53125 C9.9140625,14.7291667 10.8776042,14.328125 12.0078125,14.328125 C13.1380208,14.328125 14.1015625,14.7265625 14.8984375,15.5234375 C15.6953125,16.3203125 16.09375,17.2864583 16.09375,18.421875 C16.09375,18.578125 16.1484375,18.7109375 16.2578125,18.8203125 C16.3671875,18.9296875 16.5,18.984375 16.65625,18.984375 Z M12,12.5 C11.125,12.5 10.375,12.1875 9.75,11.5625 C9.13541667,10.9375 8.828125,10.1875 8.828125,9.3125 C8.828125,8.4375 9.13802083,7.69010417 9.7578125,7.0703125 C10.3776042,6.45052083 11.125,6.140625 12,6.140625 C12.875,6.140625 13.6223958,6.45052083 14.2421875,7.0703125 C14.8619792,7.69010417 15.171875,8.4375 15.171875,9.3125 C15.171875,10.1875 14.8619792,10.9375 14.2421875,11.5625 C13.6223958,12.1875 12.875,12.5 12,12.5 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-/-User-Icons-/-Regular-/-User" transform="translate(0.266055, 0.000000)">
                <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1"></use>
                </mask>
                <use id="User" :fill="color" fill-rule="nonzero" xlink:href="#path-1"></use>
                <g id="Color-/-Purple-Color-/-Grey-/-Dark-1" mask="url(#mask-2)" fill="#646C9A">
                    <g id="Color-/-Dark-Grey" transform="translate(-8.000000, -8.000000)">
                        <rect x="0" y="0" width="40" height="40"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'UserSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
